// @ts-nocheck
/**
 * Resolve the badge variant for a shareholder row.
 *
 * - In-progress signing: callers pass `signed` + `vote` to override the row's stored status.
 * - Closed rooms: any still-pending row collapses to `'closed'`.
 * - Otherwise: the row's own `status` (`'pending' | 'approved' | 'disapproved' | 'viewed'`).
 */
export const getShareholderVoteStatus = (shareholder, { voteRoomClosed = false, signed = false, vote = null } = {}) => {
  if (signed && vote) {
    return vote === 'approve' ? 'approved' : 'disapproved';
  }
  const status = shareholder?.status || 'pending';
  if (voteRoomClosed && status === 'pending') {
    return 'closed';
  }
  return status;
};
